export default {
    navbar: {
        searchPlaceholder: "Pretraži",
        latest: "Najnovije ponude",
        sales: "Sniženja",
        under10: "Ispod 10€",
        grabIt: "Još malo pa nestalo",
        stores: "Prodavnice",
        allCategories: "Sve kategorije",
        dropdown: {
            welcome: "Dobro došli",
            myOrders: "Moje narudžbine",
            myStores: "Moje prodavnice",
            wishlist: "Lista želja",
            cart: "Moja korpa",
            settings: "Podešavanja",
            createStore: "Kreiraj prodavnicu",
            help: "Pomoć",
            logout: "Odjavi se",
            login: "Prijava",
            register: "Registracija",
            chat: "Poruke",
            notificationCenter: "Notifikacioni centar"
        },
    },
    home: "Početna"
};
